import {css} from "lit";

export const commonStyles = css`
	/* General font */
	* {
		font-family: var(--pn-font-family-base);
	}

	button {
		margin: 0;
		padding: 0;
		background-color: transparent;
		border: none;
		font-family: var(--pn-font-family-base);
		cursor: pointer;
	}
	button:hover, button:focus, button:active {
		background-image: none;
		outline: none;
	}

	ul {
		display: block;
		margin: 0;
	}

	.dotted-focus-outline:focus {
		outline: thin dotted;
		outline-offset: 0px;
	}

	@media print {
		.shadow-content {
			display: none! important;
		}
	}

	/** Ul Nodes **/
	ul.aa-list {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: block;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	/** Li Nodes **/
	li.aa-list-item {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: block;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	/** Links **/
	a, .link-style {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: inline;
		margin: 0;
		padding: 0;
		background: none;
		color: var(--pn-color-link);
		font-family: var(--pn-font-family-base);
		font-weight: 500;
		font-size: var(--pn-font-size-base);
		text-decoration: none;
		cursor: pointer;
	}

	a:active, a:hover, a:focus, a:visited {
		outline: none;
		outline-offset: 0;
		background: none;
		color: var(--pn-color-link);
		text-decoration: underline;
	}

	.text-ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.dotted-focus-outline:focus {
		outline: thin dotted;
		outline-offset: 0px;
	}

	/** Success/Error Messages **/
	.msg-success-with-bg, .msg-error-with-bg {
		border-radius: 5px;
		padding: 5px 10px;
	}

	.msg-success-with-bg {
		color: var(--pn-success-msg-text-color);
		background-color: var(--pn-success-msg-bg-color);
	}

	.msg-error-with-bg {
		color: var(--pn-error-msg-colored-bg-text-color);
		background-color: var(--pn-error-msg-colored-bg-bg-color);
	}
`;
